export default __webpack_public_path__ + "static/3-restaurant-page-5013a4558a10e88c0d5da9315d6de98d.jpg";